import { createTheme } from '../../../../../theme';

const theme = createTheme({
  mode: 'light',
});

export const KeyAttributesItemStyle = {
  card: {
    border: '1px solid #E3E3E3',
    borderRadius: '16px',
    marginTop: '16px',
    backgroundColor: 'transparent',
  },
  cardContent: {
    padding: '12px',
  },
  box: {
    marginRight: '2px',
    marginLeft: '2px',
    display: 'flex',
  },
  nameField: { marginTop: '4px' },
  descriptionField: {
    marginTop: '12px',
    marginBottom: '12px',
  },
  formHelper: {
    style: { marginLeft: '4px' },
  },
  icon: {
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    marginTop: '14px',
  },
};

export const boxFlexDirection = 'column';
